/**
 * Created by eng210 on 29.08.2017.
 */

import {StalkerClient} from "../api/clients";

export default class StalkerApiManager {

    static myInstance = null;

    _mac = '24:4B:03:D3:B7:E5';
    _loader = new StalkerClient();
    _inited = false;

    static getInstance() {
        if (this.myInstance == null) {
            this.myInstance = new StalkerApiManager();
        }

        return this.myInstance;
    }

    getLoader() {

        if (!this._inited) {
            this._loader.init();
            this._inited = true;
        }

        return this._loader;
    }

    getMac() {
        return this._mac;
    }

    setMac(mac) {
        return this._mac = mac;
    }

}


// WEBPACK FOOTER //
// ./src/api/StalkerApiLoaderManager.js